/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Guide_Manager_Detect_Overlap_TooltipInputs */



/**
* | output |
* | --- |
* | "Check that event times do not overlap with another event(s)." |
*
* @param {Style_Guide_Manager_Detect_Overlap_TooltipInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_manager_detect_overlap_tooltip = /** @type {((inputs?: Style_Guide_Manager_Detect_Overlap_TooltipInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_Manager_Detect_Overlap_TooltipInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Verifier que les temps d'evenement ne se chevauchent pas avec d'autres evenements.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Prüfen Sie, ob sich die Veranstaltungszeiten nicht mit anderen Veranstaltungen überschneiden.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Verificare che gli orari degli eventi non si sovrappongano con altri eventi.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Убедитесь, что время проведения мероприятий не совпадает со временем проведения других мероприятий.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Verifique que los horarios de los eventos no se superpongan con los de otros eventos.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("检查活动时间是否与其他活动重叠。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベントの時間が他のイベントと重複していないことを確認してください。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("यह सुनिश्चित करें कि किसी कार्यक्रम का समय किसी अन्य कार्यक्रम के समय से मेल न खाए।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Verifique se os horários dos eventos não se sobrepõem a outros eventos.")
	return /** @type {LocalizedString} */ ("Check that event times do not overlap with another event(s).")
});